<template>
  <div class="silder-wrapper" :class="fullscreen ? 'full-silder-wrapper' : ''">
    <span class="full-screen" @click="showBigSolder" v-if="!isHideFill">
      <img v-if="fullscreen" src="../assets/exitfullscreen.svg" alt="">
      <img v-else src="../assets/fullscreen.svg" alt="">
    </span>
    <div id="product-slide" class="carousel slide carousel-wrapper" data-ride="carousel" data-interval="false">
      <div class="carousel-inner">
        <div v-for="(pic, index) of picts" :key="index" class="carousel-item" :class="index === 0 ? 'active': ''">
          <img v-if="pic.type === 'img' " :src="pic.url" class="img-item" alt="">
          <video v-else-if="pic.type === 'video'" class="video-js vjs-big-play-centered d-block w-100" controls preload="auto" poster="" data-setup='{}' @play="videoOnPlay($event)">
            <source :src="pic.url" type="video/mp4" />
          </video>
          <!-- <div v-else-if="pic.type === 'pdf'" class="pdf-item" :id="`pdf-${index}`" :data-init="initPdf(`#pdf-${index}`, pic.url)"></div> -->
          <div v-else-if="pic.type === 'pdf'" class="pdf-item" :id="`pdf-${index}`">
            <iframe :src="'https://cdnzyzs.secsa.cn/qingbohuizs/2024/pdf.js-0.8.1334/web/viewer.html?file=' + encodeURIComponent(pic.url)" style="width: 100%;height: 100%;" frameborder="0"></iframe>
          </div>
        </div>
      </div>
      <a v-if="picts.length>1" class="carousel-control-prev" href="#product-slide" role="button" data-slide="prev" @click="changePre">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a v-if="picts.length>1" class="carousel-control-next" href="#product-slide" role="button" data-slide="next" @click="changeNext">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
      <div class="silde-counter">
        <span>{{current}}/{{picts.length}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slide',
  props: ['picts', 'isHideFill'],
  data() {
    return {
      current: 1,
      fullscreen: false,
    }
  },
  created() {
    // console.log('图片')
    // console.log(this.picts.length,'有几张')
    if (location.href.indexOf('starlight/breakingNews') > -1 || location.href.indexOf('kr_view?scene=d-01') > -1) {
      this.fullscreen = true
    }
  },
  methods: {
    changePre() {
      this.videoOnPlay()
      if (this.current > 1) {
        this.current -= 1
      } else {
        this.current = this.picts.length
      }
    },
    changeNext() {
      this.videoOnPlay()
      if (this.current < this.picts.length) {
        this.current += 1
      } else {
        this.current = 1
      }
    },
    showBigSolder() {
      this.fullscreen = !this.fullscreen
    },
    initPdf(elId, src) {
      this.$nextTick(() => {
        /* eslint-disable */
        PDFObject.embed(src, elId)
        /* eslint-enable */
      })
      return elId
    },
    videoOnPlay(e) {
      if (e) {
        window.$('video').each(function () {
          if (window.$(this)[0] !== window.$(e.target)[0]) {
            window.$(this)[0].pause()
          }
        })
      } else {
        window.$('video').each(function () {
          window.$(this)[0].pause()
        })
      }
    },
  },
}
</script>

<style scoped>
.silder-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.full-silder-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.full-screen {
  padding: 6px;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 100;
  cursor: pointer;
}
.carousel-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.carousel-inner,
.carousel-item,
.video-js {
  width: 100%;
  height: 100%;
  text-align: center;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.6);
}
.pdf-item {
  width: 100%;
  height: 100%;
}
.carousel-item::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0px;
  vertical-align: middle;
}
.img-item {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  display: inline-block;
}
/* .video-js {
    width: 70rem;
    height: 38.5rem;
  } */
.carousel-control-prev,
.carousel-control-next {
  top: 40%;
  bottom: 40%;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 34px;
  height: 34px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  border: 5px solid transparent;
}
.silde-counter {
  position: absolute;
  bottom: 0px;
  left: 50%;
  color: #ffffff;
  transform: translateX(-50%);
  padding: 3px 6px;
  background-color: rgba(0, 0, 0, 0.4);
}
</style>
